var configDatas = [
  {
    mobile_show_badges: 1,
    desktop_show_badges: 1,
    mobile_show_labels: 1,
    desktop_show_labels: 1,
    label_id: 102623,
    name: "3 CUOTAS SIN INTERÉS",
    priority: 0,
    img_url: "",
    pages: "1,2,3,4,7,5",
    enable_allowed_countries: false,
    locations: "",
    position: 0,
    product_type: 3,
    exclude_products: 6,
    product: "",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: false,
    from_date: null,
    to_date: null,
    enable_discount_range: false,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url: "",
    label_text: "3%20CUOTAS%20SIN%20INTER%C9S",
    label_text_color: "#000000",
    label_text_font_size: 10,
    label_text_background_color: "#fade53",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_text_unlimited_stock: "Unlimited Stock",
    label_shadow: 1,
    label_shape: "rectangle",
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 1,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: "all_customer_tags",
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 10,
    label_text_id: 102623,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: null,
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3: "",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2023-12-06T04:41:39.000Z",
    customer_ids: "",
    exclude_customer_ids: "",
    exclude_product_ids: "",
    angle: 0,
    toolTipText: "",
    mobile_width_label: 41,
    mobile_height_label: 10,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 41,
    desktop_height_label: 10,
    desktop_fixed_percent_label: 1,
    mobile_position: 0,
    mobile_default_config: 1,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time: null,
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: 0,
    enable_badge_stock: 0,
    translations: [],
    animation_type: 0,
    img_plan_id: 0,
  },
];
